/* Talmuro Focus — cart drawer + product form */
(function () {
  var MONEY = (window.TM && window.TM.moneyFormat) || '${{amount}}';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || MONEY;
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    function fmt(n, dec, th, ds) {
      dec = dec == null ? 2 : dec; th = th || ','; ds = ds || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(dec);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return d + (parts[1] ? ds + parts[1] : '');
    }
    var v;
    switch (key) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  window.TMformatMoney = formatMoney;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- CART DRAWER ---------- */
  var drawer = document.querySelector('[data-tm-drawer]');
  function setCount(n) {
    document.querySelectorAll('[data-tm-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    var items = drawer.querySelector('[data-tm-items]');
    var foot = drawer.querySelector('[data-tm-foot]');
    if (!cart.item_count) {
      items.innerHTML = '<div class="tm-drawer__empty"><p>' + esc(drawer.dataset.empty) + '</p><button class="tm-btn" data-tm-close>' + esc(drawer.dataset.continue) + '</button></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    items.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      return '<div class="tm-line">' +
        '<div class="tm-line__img">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</div>' +
        '<div class="tm-line__i"><b>' + esc(it.product_title) + '</b>' +
        (variant ? '<div class="tm-line__v">' + esc(variant) + '</div>' : '<div class="tm-line__v"></div>') +
        '<div class="tm-line__row"><div class="tm-qty"><button data-tm-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="-">−</button><span>' + it.quantity + '</span><button data-tm-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="+">+</button></div>' +
        '<b>' + formatMoney(it.final_line_price) + '</b></div>' +
        '<button class="tm-line__rm" data-tm-line="' + (i + 1) + '" data-q="0">' + esc(drawer.dataset.remove) + '</button>' +
        '</div></div>';
    }).join('');
    drawer.querySelector('[data-tm-subtotal]').textContent = formatMoney(cart.total_price);
  }
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function openDrawer() {
    if (!drawer) { window.location.href = '/cart'; return; }
    fetchCart().then(renderCart);
    drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
  window.TMopenCart = openDrawer;

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-tm-open-cart]')) { e.preventDefault(); openDrawer(); }
    else if (t.closest('[data-tm-close]')) { e.preventDefault(); closeDrawer(); }
    else if (t.closest('[data-tm-line]')) {
      var b = t.closest('[data-tm-line]');
      b.disabled = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +b.dataset.tmLine, quantity: Math.max(0, +b.dataset.q) }) })
        .then(function (r) { return r.json(); }).then(renderCart).catch(function () { b.disabled = false; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- PRODUCT FORM ---------- */
  var SIZE_RE = /^(XXS|XS|S|M|L|XL|XXL|XXXL|2XL|3XL|4XL|\d+XL)\s*[-\/]\s*(.+)$/i;
  var VISUAL_RE = /colou?r|style|design|pattern|print|farb|couleur|renk/i;

  function initProduct(root) {
    var dataEl = root.querySelector('[data-tm-product-json]');
    if (!dataEl) return;
    var P = JSON.parse(dataEl.textContent);
    var form = root.querySelector('.tm-form');
    var idInput = form.querySelector('[name="id"]');
    var picker = root.querySelector('[data-tm-picker]');
    var btn = root.querySelector('[data-tm-atc]');
    var qtyInput = root.querySelector('[data-tm-qty]');
    var L = root.dataset;

    // Build a model of "virtual options". Normally mirrors product options;
    // a single option like "S-Duck" gets split into Style + Size.
    var model = [];
    var split = P.options.length === 1 && P.variants.length > 1 && P.variants.every(function (v) { return SIZE_RE.test(v.option1); });
    function valsFor(fn) {
      var out = [];
      P.variants.forEach(function (v) { var x = fn(v); if (out.indexOf(x) < 0) out.push(x); });
      return out;
    }
    if (split) {
      model.push({ name: L.styleLabel || 'Style', visual: true, get: function (v) { return v.option1.match(SIZE_RE)[2].trim(); } });
      model.push({ name: L.sizeLabel || 'Size', visual: false, get: function (v) { return v.option1.match(SIZE_RE)[1].toUpperCase(); } });
    } else {
      P.options.forEach(function (name, i) {
        var key = 'option' + (i + 1);
        var hasImgs = P.variants.some(function (v) { return v.featured_image; });
        model.push({ name: name, visual: VISUAL_RE.test(name) && hasImgs, get: function (v) { return v[key]; } });
      });
    }
    model.forEach(function (o) { o.values = valsFor(o.get); });

    var current = P.variants.find(function (v) { return v.id === P.selected; }) || P.variants.find(function (v) { return v.available; }) || P.variants[0];
    var sel = model.map(function (o) { return o.get(current); });

    function findVariant(s) {
      return P.variants.find(function (v) { return model.every(function (o, i) { return o.get(v) === s[i]; }); });
    }
    function imgFor(oi, val) {
      var v = P.variants.find(function (v) { return model[oi].get(v) === val && v.featured_image; });
      return v ? v.featured_image.src : '';
    }
    function sized(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

    function renderPicker() {
      if (P.variants.length === 1 && P.variants[0].title === 'Default Title') { picker.innerHTML = ''; return; }
      picker.innerHTML = model.map(function (o, oi) {
        var html = '<div class="tm-opt"><div class="tm-opt__label">' + esc(o.name) + ': <em>' + esc(sel[oi]) + '</em></div>';
        html += o.visual ? '<div class="tm-swatches">' : '<div class="tm-pills">';
        html += o.values.map(function (val) {
          var trial = sel.slice(); trial[oi] = val;
          var tv = findVariant(trial);
          var na = !tv || !tv.available;
          var act = sel[oi] === val;
          if (o.visual) {
            return '<button type="button" class="tm-sw' + (act ? ' is-active' : '') + (na ? ' is-na' : '') + '" data-oi="' + oi + '" data-val="' + esc(val) + '" aria-pressed="' + act + '"><div class="tm-sw__img"><img src="' + esc(sized(imgFor(oi, val), 160)) + '" alt="' + esc(val) + '" loading="lazy"></div><span>' + esc(val) + '</span></button>';
          }
          return '<button type="button" class="tm-pill' + (act ? ' is-active' : '') + (na ? ' is-na' : '') + '" data-oi="' + oi + '" data-val="' + esc(val) + '" aria-pressed="' + act + '">' + esc(val) + '</button>';
        }).join('');
        return html + '</div></div>';
      }).join('');
    }

    function update(scroll, ci) {
      var v = findVariant(sel);
      if (!v) {
        // keep the option the shopper just clicked, adjust the others
        ci = ci || 0;
        var match = function (x) { return model[ci].get(x) === sel[ci]; };
        v = P.variants.find(function (x) { return match(x) && x.available; }) || P.variants.find(match) || P.variants[0];
        sel = model.map(function (o) { return o.get(v); });
      }
      current = v;
      idInput.value = v.id;
      renderPicker();
      root.querySelectorAll('[data-tm-price]').forEach(function (el) { el.textContent = formatMoney(v.price); });
      var was = root.querySelector('[data-tm-was]');
      var save = root.querySelector('[data-tm-save]');
      if (v.compare_at_price && v.compare_at_price > v.price) {
        was.textContent = formatMoney(v.compare_at_price); was.hidden = false;
        save.textContent = (L.saveLabel || 'SAVE') + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; save.hidden = false;
      } else { was.hidden = true; save.hidden = true; }
      document.querySelectorAll('[data-tm-atc], [data-tm-sticky-atc]').forEach(function (b) {
        b.disabled = !v.available;
        var lbl = b.querySelector('[data-label]') || b;
        lbl.textContent = v.available ? (b.dataset.addLabel || L.addLabel) : L.soldLabel;
      });
      var sv = document.querySelector('[data-tm-sticky-variant]');
      if (sv) sv.textContent = (v.title !== 'Default Title' ? v.title + ' · ' : '') + formatMoney(v.price);
      if (scroll && v.featured_media) goToMedia(v.featured_media.id);
      if (window.history.replaceState && root.dataset.updateUrl === 'true') {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      }
    }

    // gallery
    var main = root.querySelector('[data-tm-gal-main]');
    var thumbs = root.querySelectorAll('[data-tm-thumb]');
    function goToIndex(i) {
      if (!main) return;
      var slide = main.children[i]; if (!slide) return;
      main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: 'smooth' });
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
    }
    function goToMedia(id) {
      if (!main) return;
      var idx = Array.prototype.findIndex.call(main.children, function (s) { return +s.dataset.mediaId === id; });
      if (idx > -1) goToIndex(idx);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goToIndex(i); }); });
    if (main) main.addEventListener('scroll', function () {
      var i = Math.round(main.scrollLeft / main.clientWidth);
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
    }, { passive: true });

    picker.addEventListener('click', function (e) {
      var b = e.target.closest('[data-oi]'); if (!b) return;
      sel[+b.dataset.oi] = b.dataset.val;
      update(true, +b.dataset.oi);
    });

    root.querySelectorAll('[data-tm-qbtn]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (+qtyInput.value || 1) + (+b.dataset.tmQbtn));
      });
    });

    function addToCart(button) {
      if (!current || !current.available) return;
      var label = button.querySelector('[data-label]') || button;
      var orig = label.textContent;
      button.disabled = true; label.textContent = L.addingLabel || '...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: current.id, quantity: Math.max(1, +(qtyInput && qtyInput.value) || 1) }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { openDrawer(); })
        .catch(function (err) { alert((err && (err.description || err.message)) || 'Error'); })
        .finally(function () { button.disabled = false; label.textContent = orig; });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(btn); });
    var stickyBtn = document.querySelector('[data-tm-sticky-atc]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { addToCart(stickyBtn); });

    // sticky visibility
    var sticky = document.querySelector('[data-tm-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting) seen = true;
          sticky.classList.toggle('is-on', !x.isIntersecting && seen && x.boundingClientRect.top < 0);
        });
      }).observe(btn);
    }

    // size chart modal
    var sizeBtn = root.querySelector('[data-tm-size-open]');
    var dlg = root.querySelector('[data-tm-size]');
    if (sizeBtn && dlg) {
      sizeBtn.addEventListener('click', function () { dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', ''); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-tm-size-close]')) dlg.close(); });
    }

    // delivery dates
    root.querySelectorAll('[data-tm-date]').forEach(function (el) {
      var r = el.dataset.tmDate.split('-').map(Number);
      function d(n) { var x = new Date(); x.setDate(x.getDate() + n); return x.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); }
      el.textContent = r.length > 1 && r[1] !== r[0] ? d(r[0]) + ' – ' + d(r[1]) : d(r[0]);
    });

    update(false);
  }

  document.querySelectorAll('[data-tm-product]').forEach(initProduct);
  fetchCart().then(function (c) { setCount(c.item_count); }).catch(function () {});
})();
